import { Quote } from "lucide-react";
import { SectionHeading, Reveal } from "@/components/Reveal";

const QUOTES = [
  {
    quote:
      "NGCONDE runs dedicated bakkie linehaul on our busiest corridors. Manifests are accurate, PODs come back the same day, and when our volumes spike they absorb the overflow without drama.",
    author: "Regional Operations Manager",
    company: "RTT",
    category: "Linehaul & Last-Mile Subcontracting",
  },
  {
    quote:
      "We contracted NGCONDE for scheduled retail replenishment runs and they have never missed a window. Direct owner-to-owner communication makes dispatch refreshingly simple.",
    author: "Fleet & Contracts Lead",
    company: "Mua Logistics",
    category: "Dedicated Bakkie Fleet Contract",
  },
  {
    quote:
      "Peak-season overflow capacity was live within 72 hours of signing. Their drivers know our gates, the paperwork is clean, and escalation is one phone call away.",
    author: "Supply Chain Manager",
    company: "National E-commerce Retailer",
    category: "Peak Season Overflow Agreement",
  },
  {
    quote:
      "Consistent, communicative and properly documented — exactly what a distribution operation needs from a contracted delivery partner.",
    author: "Distribution Centre Manager",
    company: "FMCG Distributor",
    category: "Scheduled Distribution Runs",
  },
];

export const Quotes = () => (
  <section className="bg-[#0D1424] py-20 md:py-28" data-testid="quotes-section">
    <div className="mx-auto max-w-7xl px-5 lg:px-8">
      <SectionHeading
        eyebrow="Partner Feedback"
        title="What partners say on contract."
      />

      <div className="mt-12 grid grid-cols-1 gap-4 md:grid-cols-2 md:gap-5">
        {QUOTES.map((q, i) => (
          <Reveal key={q.company + q.author} delay={(i % 2) * 0.1} className="h-full">
            <figure
              data-testid={`quote-card-${i + 1}`}
              className="flex h-full flex-col rounded-2xl border border-white/10 bg-[#080C14] p-7 transition-colors duration-300 hover:border-[#FF6B00]/50 md:p-9"
            >
              <Quote className="h-7 w-7 text-[#FF6B00]" />
              <blockquote className="mt-5 flex-1 text-base leading-relaxed text-slate-300 md:text-lg">
                {q.quote}
              </blockquote>
              <figcaption className="mt-6 border-t border-white/10 pt-5">
                <p className="font-mono text-xs font-semibold uppercase tracking-[0.18em] text-white">
                  {q.author} — <span className="text-[#FF6B00]">{q.company}</span>
                </p>
                <p className="mt-1 font-mono text-[10px] uppercase tracking-[0.18em] text-slate-500">
                  {q.category}
                </p>
              </figcaption>
            </figure>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.15}>
        <p className="mt-6 font-mono text-[11px] uppercase tracking-[0.18em] text-slate-500">
          Reference letters and a verifiable track record are available to procurement
          teams on request.
        </p>
      </Reveal>
    </div>
  </section>
);
